<div class="my-app-tiles-container">
    <div class="row justify-content-between no-gutters">
        <div>
            <h2 i18n="my app tiles title@@my-app-tiles-title" class="widget-header h4">Apps &amp; tools</h2>
            <h3 class="text-muted h6" i18n="my app tiles sub title@@my-app-tiles-sub-title">
                Here you'll find your apps and tools. You can enable edit mode to change your collection, or go to the App center to browse and add available apps.
            </h3>
        </div>
        <div class="mt-2 mt-xxl-1">
            <mat-slide-toggle title="Edit your apps" i18n-title="@@edit-your-apps" i18n-aria-label="@@edit-your-apps" aria-label="Edit your apps" [checked]="editMode" (change)="handleEditMode($event)" (keyup.arrowright)="handleEditMode($event)" (keyup.arrowleft)="handleEditMode($event)" class="align-middle" i18n="my app tiles edit@@my-app-tiles-edit">Edit</mat-slide-toggle>
            <i class="ms-Icon ms-Icon--Separator ml-2 mr-2 align-middle" title="Separator" aria-hidden="true"></i>
            <mat-slide-toggle [checked]="showHidden" (change)="handleShowHidden($event)" (keyup.arrowright)="handleShowHidden($event)" (keyup.arrowleft)="handleShowHidden($event)" class="align-middle" *ngIf="editMode" i18n="my app tiles hidden@@my-app-tiles-hidden">Hidden</mat-slide-toggle>
            <i class="ms-Icon ms-Icon--Separator ml-2 mr-2 align-middle" title="Separator" aria-hidden="true" *ngIf="editMode"></i>
            <app-action-router-link [actionRouterLink]="'/apps-and-tools'" [buttonClass]="'align-middle'">
                <span i18n="go to app center@@go-to-app-center">Go to the app center</span>
                <i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
            </app-action-router-link>
        </div>
    </div>
    <div class="row">
        <div class="col-auto">
            <div *ngIf="userAppTiles$ | async; else loading" class="my-app-tiles-list justify-content-between justify-content-md-start row" [sortablejs]="editMode ? userAppTiles : []" [sortablejsOptions]="editMode ? options : {disabled:true}">
                <div *ngFor="let userAppTile of userAppTiles" class="col-auto mt-4 app-tile-square-wrapper" [ngClass]="editMode ? 'shake' : 'ignore-elements'">
                    <app-app-tile-box [appTile]="userAppTile.AppTile"
                                      [userAppTile]="userAppTile"
                                      [editMode]="editMode"
                                      (removalEvents)="handleRemove($event, userAppTiles)"></app-app-tile-box>
                </div>
                <div class="col-auto mt-4" *ngIf="userAppTiles.length === 0 && !editMode">
                    <app-text-placeholder>
                        <p i18n="no apps added@@no-apps-added">You have no apps and tools here at the moment. Add a new personal one by clicking on edit or go to the app center to get some existing apps.</p>
                    </app-text-placeholder>
                </div>
            </div>
        </div>
        <div class="col-auto">
            <div class="row">
                <div class="col-auto ignore-elements mt-4" *ngIf="editMode">
                    <a mat-button [routerLink]="['',{ outlets: { modal: ['user-app-tiles','add'] } }]" class="p-0 add-new-app-clickable-link">
                        <div class="text-center app-tile-square position-relative border border-dashed border-dark-color clickable d-block">
                            <div class="icon-section">
                                <i class="ms-Icon ms-Icon--Add display-4" title="Click here to add a new app" aria-hidden="true"></i>
                            </div>
                        </div>
                    </a>
                    <span class="mt-2 d-block bolder text-center" i18n="my app tile add@@my-app-tile-add">Add new app</span>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #loading>
    <div class="mt-4" *ngIf="errorSubject$ | async as err; else innerLoading">
        <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
    </div>
    <ng-template #innerLoading>
        <div class="mt-4">
            <app-widget-placeholder [useGhostContent]="true">
                <div class="row">
                    <div class="col-1">
                        <div class="ghost-app-tile bg-subtle-color"></div>
                    </div>
                    <div class="col-1">
                        <div class="ghost-app-tile bg-subtle-color"></div>
                    </div>
                    <div class="col-1">
                        <div class="ghost-app-tile bg-subtle-color"></div>
                    </div>
                </div>
            </app-widget-placeholder>
        </div>
    </ng-template>
</ng-template>
